// @core/api/endpoints/affiliate/list_conversions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListConversionsResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List conversions
 * Returns a paginated list of conversions. Supports filtering and sorting.
 */
export async function ListConversions(
  params?: PaginatedRequest & {
    affiliate_id?: string | number | boolean;
    campaign_id?: string | number | boolean;
    offer_id?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListConversionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/conversions`;
  const requestOptions = options;
  return client.get<ListConversionsResponse>(requestPath, { ...requestOptions, params });
}
